export class ApiError extends Error {
  status: number;
  details?: Record<string, number | string>;

  constructor(message: string, status: number, details?: Record<string, number | string>) {
    super(message);
    this.status = status;
    this.details = details;
  }
}

export async function api<T>(path: string, options: RequestInit = {}): Promise<T> {
  const response = await fetch(`/api${path}`, {
    credentials: 'include',
    ...options,
    headers: {
      ...(options.body ? { 'Content-Type': 'application/json' } : {}),
      ...options.headers
    }
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) throw new ApiError(data.error || 'Ошибка запроса', response.status, data.details);
  return data as T;
}

export const post = <T,>(path: string, body?: unknown) => api<T>(path, {
  method: 'POST',
  body: body === undefined ? undefined : JSON.stringify(body)
});

export const patch = <T,>(path: string, body: unknown) => api<T>(path, {
  method: 'PATCH',
  body: JSON.stringify(body)
});
